/**
 * A list of all users that we create in current.sqlite.
 *
 * services/users/cmd/create_dev_users creates some "fake" users
 * when we sync content-data from prod into current.sqlite.  It can
 * be useful to log in as those fake users, since they have some
 * activity that is useful for testing (e.g. you can log in as
 * a coach whose student recently did an exercise).
 *
 * This file lists all the users that create_dev_users creates, so
 * the login form can do an "easy login" for them.
 *
 * Keep this list in alphabetical order by username.
 */
export default [
    // sync-start:dev-users 1728586903 https://github.com/Khan/webapp/blob/master/services/users/cmd/create_dev_users/create_users.go
    {
        username: "testadmin",
        password: "khan1",
        bio: "has all permissions and capabilities",
    },
    {
        username: "testcoach",
        password: "khan1",
        bio: "a google-user coach of teststudent and testchild",
    },
    {
        username: "testcontenteditor",
        password: "khan1",
        bio: "can edit content",
    },
    {
        username: "testmaybestudent",
        password: "khan1",
        bio: "a user testcoach requested to coach",
    },
    {
        username: "testmoderator",
        password: "khan1",
        bio: "has moderator permissions; coaches testcoach/teststudent",
    },
    {
        username: "testnweasupporter",
        password: "khan1",
        bio: "has the permissions of nwea support staff",
    },
    {
        username: "testpublisher",
        password: "khan1",
        bio: "has content editing and publish capabilities",
    },
    {
        username: "testescontenteditor",
        password: "khan1",
        bio: "has content editor capabilities for es only",
    },
    {
        username: "testchild",
        password: "khan1",
        bio: "a spawned child of testcoach",
    },
    {
        username: "teststudent",
        password: "khan1",
        bio: "a spawned coachee of testcoach",
    },
    {
        username: "teststudent2",
        password: "khan1",
        bio: "a non-spawned coachee testcoach and teststudent",
    },
    {
        username: "testunverified",
        password: "khan1",
        bio: 'an unverified user with the "resend email" banner notification',
    },
    // sync-end:dev-users
    {
        username: "testunverified2",
        password: "khan1",
        bio: 'an unverified user with the "change email" banner notification',
    },
];
